import { createContext } from 'react';
import type { ContainerWidthType } from 'pos-client/hooks/useContainerWidth';

export interface PosGridContextProps extends ContainerWidthType {
  responsive: 'container' | 'screen';
}

export const PosGridContext = createContext<PosGridContextProps>({
  responsive: 'container',
  width: 0,
  currentBreakpoint: 'xxl',
  breakpointsGreater: {
    xxl: false,
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xs: false,
  },
  breakpointsLess: {
    xxl: false,
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xs: false,
  },
});
